import { render, staticRenderFns } from "./showMap.vue?vue&type=template&id=31a2484a&scoped=true&"
import script from "./showMap.vue?vue&type=script&lang=tsx&"
export * from "./showMap.vue?vue&type=script&lang=tsx&"
import style0 from "./showMap.vue?vue&type=style&index=0&id=31a2484a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a2484a",
  null
  
)

export default component.exports